import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetNotificationTemplateDBTableFieldList = (params) =>
    GET_ENC(`${BASE_URL}/api/NotificationTemplateDBTableField/GetList?` + params, null);

export const GetNotificationTemplateTemplateDetailById = (params: any) =>
    GET_ENC(`${BASE_URL}/api/NotificationTemplateTemplate/GetDetail?` + params, null);

export const GetNotificationTemplateTemplateList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/NotificationTemplateTemplate/GetList?` + params, null);

export const CreateNotificationTemplateTemplate = (data: any) =>
    POST_ENC(`${BASE_URL}/api/NotificationTemplateTemplate/Create`, data);

export const UpdateNotificationTemplateTemplate = (data: any) =>
    POST_ENC(`${BASE_URL}/api/NotificationTemplateTemplate/Update`, data);

export const DeleteNotificationTemplateTemplate = (data: any) =>
    POST_ENC(`${BASE_URL}/api/NotificationTemplateTemplate/Delete`, data);

export const GetNotificationTemplateListForSelect = () =>
    GET_ENC(`${BASE_URL}/api/NotificationTemplate/GetListForSelect?`, null);